// Lightweight theme manager. Stores choice in localStorage and applies
// data-theme attribute + a `theme-light` / `theme-dark` class to <html>.
// Default is "dark".

const STORAGE_KEY = "ft.theme";

export function getStoredTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY) || "dark";
  } catch {
    return "dark";
  }
}

export function applyTheme(theme) {
  const t = theme === "light" ? "light" : "dark";
  const html = document.documentElement;
  html.setAttribute("data-theme", t);
  html.classList.remove("theme-light", "theme-dark");
  html.classList.add(`theme-${t}`);
  html.style.colorScheme = t;
  try {
    localStorage.setItem(STORAGE_KEY, t);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent("ft:theme-change", { detail: { theme: t } }));
}

export function toggleTheme() {
  const cur = getStoredTheme();
  applyTheme(cur === "dark" ? "light" : "dark");
}

